import logo from "./assets/images/SAIT_Logo.png";

function Header({ openModal }) {
  return (
    <header className="header">
      <img
        src={logo}
        alt="SAIT Logo"
        className="logo"
      />

      <button
        className="contact-btn"
        onClick={openModal}
      >
        Contact Us
      </button>
    </header>
  );
}

export default Header;